import React from 'react';
import { Link } from 'react-router-dom';
import churchPeopleImg from "../../assests/church_people.jpg";
import churchBuildingImg from "../../assests/white_house.jpg";
import inaugurationImg from "../../assests/ribbon_cutting.jpg";

function PlantingChurches() {
  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#333",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "0 1.5rem 3rem",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            fontSize: "13px",
            marginTop: "1.5rem",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            color: "#ef7d32",
            fontSize: "2.8rem",
            marginBottom: ".3rem",
          }}
        >
          Planting Churches in Unreached Areas
        </h1>

        {/* Orange Dots */}
        <div
          style={{
            display: "flex",
            gap: 4,
            marginBottom: "2rem",
          }}
        >
          {[...Array(12)].map((_, i) => (
            <span
              key={i}
              style={{
                width: 5,
                height: 5,
                borderRadius: "50%",
                background: "#ef7d32",
              }}
            />
          ))}
        </div>

        {/* Intro */}
        <p
          style={{
            fontSize: "14px",
            lineHeight: "1.9",
            marginBottom: "2rem",
          }}
        >
          The New Testament Church of India is a church pioneering ministry
          established in December 1982. Today there are more than 200
          congregations throughout Andhra Pradesh, Kerala, Delhi, Odisha,
          Chhattisgarh, Telangana, Tamil Nadu, Maharashtra and Madhya Pradesh,
          with over 25,000 members. We support pastors serving in unreached
          villages until their churches become self-supporting.
        </p>

        {/* Main Content */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}
        >
          {/* Left Image */}
          <img
            src={churchPeopleImg}
            alt="Church Gathering"
            style={{
              width: "470px",
              maxWidth: "100%",
              height: "320px",
              objectFit: "cover",
            }}
          />

          {/* Right Text */}
          <div
            style={{
              flex: 1,
              minWidth: "300px",
              fontSize: "14px",
              lineHeight: "1.9",
            }}
          >
            <p>
              Church structures are constructed and continue to be New
              Testament Churches of India property. The church encourages the
              abolition of social evils while supporting the battle against
              drugs and alcohol. It also engages in counselling, relief and
              rehabilitation work and promotes literacy in rural areas where
              schools are not available.
            </p>

            <p>
              In the New Testament Churches of India, both men and women are
              encouraged to serve in Christian ministry. Many pastors are
              praying for a permanent place of worship so their congregations
              can continue growing and reaching more people with the Gospel.
            </p>
          </div>
        </div>

        {/* Bottom Images */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            marginTop: "2rem",
            flexWrap: "wrap",
          }}
        >
          <img
            src={churchBuildingImg}
            alt="Church Building"
            style={{
              flex: 1,
              minWidth: "320px",
              height: "270px",
              objectFit: "cover",
            }}
          />

          <img
            src={inaugurationImg}
            alt="Church Opening"
            style={{
              flex: 1,
              minWidth: "320px",
              height: "270px",
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      {/* Support Section */}
      <div
        style={{
          background: "#2d8b57",
          color: "#fff",
          textAlign: "center",
          padding: "3rem 1rem",
          marginTop: "3rem",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "36px",
            fontWeight: "bold",
          }}
        >
          Support Our Ministry
        </h2>

        <p
          style={{
            margin: "15px 0 30px",
            fontSize: "15px",
          }}
        >
          To sponsor a native pastor and his family, you can give $50 or $100
          monthly.
        </p>

        {/* PayPal Donation Button */}
        <a
          href="https://www.paypal.com/donate/?hosted_button_id=V7C9GVAEMJ2Z4"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            display: "inline-block",
          }}
        >
          <button
            type="button"
            style={{
              background: "#fff",
              color: "#2d8b57",
              border: "2px solid #fff",
              padding: "12px 35px",
              fontWeight: "bold",
              cursor: "pointer",
              fontSize: "15px",
            }}
          >
            GIVE
          </button>
        </a>
      </div>
    </div>
  );
}

export default PlantingChurches;
